import { useMemo } from 'react';

import Image from 'next/image';

import { DYNAMIC_HOTEL_IMAGE_SIZE_LABEL } from '@constants/constants';
import ImageWithFallback from '@components/utils/ImageWithFallback';

import { ImageWrapper } from './styled';

interface Props {
  url: string;
  alt?: string;
  fallBackImage?: string;
  width?: number;
  height?: number;
  useOriginalImage?: boolean;
  borderRadius?: number;
  lazyOnLoad?: boolean;
  wrapperWidth?: string;
}

const CloudinaryItemImage = ({
  url,
  alt,
  fallBackImage,
  width,
  height,
  useOriginalImage,
  borderRadius,
  lazyOnLoad = true,
  wrapperWidth,
}: Props) => {
  const imageUrl = useMemo(() => {
    if (!url) return '';

    // if the url has not dynamic size then we will return
    if (!url.includes(DYNAMIC_HOTEL_IMAGE_SIZE_LABEL)) return url;

    if (useOriginalImage)
      return url.replace(DYNAMIC_HOTEL_IMAGE_SIZE_LABEL, '');

    return url.replace(
      DYNAMIC_HOTEL_IMAGE_SIZE_LABEL,
      `h_${height},w_${width},dpr_auto,e_sharpen:200,q_auto:best`
    );
  }, [url, width, height, useOriginalImage]);

  return (
    <ImageWrapper borderRadius={borderRadius} wrapperWidth={wrapperWidth}>
      {lazyOnLoad ? (
        <ImageWithFallback
          priority={false}
          Component={Image}
          width={width}
          height={height}
          src={imageUrl}
          alt={alt ?? 'setur'}
          fallbackImage={fallBackImage}
          loading='lazy'
        />
      ) : (
        <ImageWithFallback
          priority={true}
          Component={Image}
          width={width}
          height={height}
          src={imageUrl}
          alt={alt ?? 'setur'}
          fallbackImage={fallBackImage}
        />
      )}
    </ImageWrapper>
  );
};

export default CloudinaryItemImage;
